// extracted by mini-css-extract-plugin
export var currencyInput = "_nt-1";
export var currencySymbol = "_nt-0";